// TODO: CplItemStatusSearch and RequestItemStatusSearch have the same status types but different numeric values.
// In CplItemStatusSearch: TEMPLATE = 3, PREVIEW = 5
// In RequestItemStatusSearch: TEMPLATE = 5, PREVIEW = 3
// This reflects different backend database values for Compliance Items vs Requests.
export enum CplItemStatusSearch {
    ACTIVE = 0,
    ARCHIVED = 1,
    DELETED = 2,
    TEMPLATE = 3,
    DRAFT = 4,
    PREVIEW = 5
}